export default {
  common: {
    actions: "Actions",
    add: "Ajouter",
    apply: "Appliquer",
    cancel: "Annuler",
    clear: "Vider",
    confirm: "Confirmer",
    create: "Créer",
    delete: "Supprimer",
    details: "Détails",
    edit: "Modifier",
    export: "Exporter",
    filter: "Filtrer",
    import: "Importer",
    loading: "Chargement...",
    manageColumns: "Gérer les colonnes",
    noData: "Aucune donnée disponible",
    downloadModel: "Télécharger le fichier modèle",
    save: "Enregistrer",
    search: "Rechercher",
    settings: "Paramètres",
    send: "Envoyer",
    tableName: "Nom de la table",
    update: "Modifier",
    validate: "Valider",
    viewTable: "Consulter la table {table}",
    clearFilters: "Vider les filtres",
    all: "Tous",
    yes: "Oui",
    no: "Non",
    na: "NA",
    refresh: "Rafraîchir",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    close: "Fermer",
    retour: "Retour",
    error: "Erreur",
    success: "Réussis",
    information: "Information"
  }
};
